import { addQueryString } from "@client/lib/api";
import { type Leaderboard } from "./types";

export const getVoteLink = (userId: number) => addQueryString(document.location.href, { rauid: userId });

export const mapIncentiveApiItem = ({
  incentiveId,
  incentiveRewardId,
  points,
  requiredPoints,
  ...item
}: Leaderboard.Api.IncentiveLeaderboardItem): Leaderboard.Item => ({
  ...item,
  id: incentiveId,
  rewardId: incentiveRewardId,
  score: points,
  requiredScore: requiredPoints,
  displayName: [item.firstName, item.lastName].filter((x) => !!x).join(" "),
  movement: item.movement ?? 0,
  type: "incentive"
});

export const mapIncentiveApiReward = ({
  incentiveRewardId,
  ...reward
}: Leaderboard.Api.IncentiveReward): Leaderboard.Reward => ({
  id: incentiveRewardId,
  ...reward
});

export const mapLaunchApiItem = ({
  launchId,
  launchRewardId,
  votes,
  requiredVotes,
  ...item
}: Leaderboard.Api.LaunchLeadboardItem): Leaderboard.Item => ({
  ...item,
  id: launchId,
  rewardId: launchRewardId,
  score: votes,
  requiredScore: requiredVotes,
  displayName: [item.firstName, item.lastName].filter((x) => !!x).join(" "),
  movement: item.movement ?? 0,
  type: "launch"
});

export const mapLaunchApiReward = ({
  launchRewardId,
  ...reward
}: Leaderboard.Api.LaunchReward): Leaderboard.Reward => ({
  id: launchRewardId,
  ...reward
});

export const getDummyItem = (): Leaderboard.Api.LaunchLeadboardItem => ({
  countryName: null,
  date: new Date().toISOString(),
  email: "dummy",
  firstName: "dummy",
  lastName: "dummy",
  launchId: "",
  launchRewardId: null,
  movement: null,
  position: 1,
  profilePictureMediaId: null,
  profilePictureMediaSourceKey: null,
  profilePictureMediaUrl: null,
  profilePictureSourceId: null,
  requiredVotes: 100,
  userId: -1,
  votes: 1
});
